// --- File: custom-scripts.js ---
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";


gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// ----------------------------------------------------------------------
// 🌿  REVEAL-ON-SCROLL ELEMENTS (FOUC-safe)
// ----------------------------------------------------------------------
function initRevealOnScroll() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.warn('GSAP or ScrollTrigger not loaded');
    return;
  }
  gsap.registerPlugin(ScrollTrigger);

  const selectors = '.reveal-on-scroll, .reveal-fade, .reveal-slide-up, .reveal-slide-left';
  const revealElements = document.querySelectorAll(selectors);
  if (!revealElements.length) return;

  revealElements.forEach((el) => {
    // Skip if already wired
    if (el.dataset.revealInit === '1') return;
    el.dataset.revealInit = '1';

    // Determine initial/target states
    const isUp    = el.classList.contains('reveal-slide-up');
    const isLeft  = el.classList.contains('reveal-slide-left');
    const from    = { opacity: 0 };
    if (isUp)   from.y = 20;
    if (isLeft) from.x = -20;

    // Delay utility via classes like .delay-100, .delay-200 ... .delay-1000
    let delay = 0;
    for (let i = 0; i <= 1000; i += 100) {
      if (el.classList.contains(`delay-${i}`)) { delay = i / 1000; break; }
    }

    gsap.fromTo(
      el,
      from,
      {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 1.2,
        delay,
        ease: 'power2.out',
        immediateRender: false,
        scrollTrigger: {
          trigger: el,
          start: 'top 80%',
          toggleActions: 'play none none none',
          once: true,
        },
      }
    );
  });

  // Stagger groups
  document.querySelectorAll('.stagger-group').forEach((group) => {
    const items = group.querySelectorAll(selectors);
    if (!items.length) return;

    // Guard: mark all as init (so we don't double-wire)
    items.forEach((el) => (el.dataset.revealInit = '1'));

    const tl = gsap.timeline({
      defaults: { ease: 'power2.out', duration: 0.6 },
      scrollTrigger: {
        trigger: group,
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true,
      },
    });

    items.forEach((item, idx) => {
      const from = { opacity: 0 };
      if (item.classList.contains('reveal-slide-up')) from.y = 30;
      if (item.classList.contains('reveal-slide-left')) from.x = -30;
      tl.fromTo(item, from, { opacity: 1, x: 0, y: 0 }, idx * 0.1);
    });
  });
}

// Init on DOM ready
document.addEventListener('DOMContentLoaded', initRevealOnScroll);

// Re-init for Shopify editor section loads
document.addEventListener('shopify:section:load', () => {
  setTimeout(initRevealOnScroll, 100);
});

// One final refresh after images/fonts finish -> prevents late layout shifts
window.addEventListener('load', () => {
  if (window.ScrollTrigger) ScrollTrigger.refresh();
});







// ----------------------------------------------------------------------
// 🚀  HOMEPAGE HERO SCROLL ANIMATION (ESM-safe, anchored bottom-right grow)
// ----------------------------------------------------------------------


(function () {
  function initNgaarluHero() {
    const hero =
      document.querySelector(".homepage-hero") ||
      document
        .querySelector(".homepage-hero .hero__content-wrapper")
        ?.closest(".shopify-section, section, .section");

    if (!hero) {
      console.warn("[Hero] Could not find hero section");
      return;
    }

    let videoBox =
      hero.querySelector(".video-grows.js-hero-video-scale") ||
      hero.querySelector(
        ".deferred-media, video, .media, .media--video, [data-media-id], img"
      );

    if (!videoBox) {
      console.warn("[Hero] Could not find video container");
      return;
    }

    const rotator = hero.querySelectorAll(".rotator-item");

    videoBox.classList.add('is-initial');

    hero.style.minHeight ||= "100svh";
    hero.style.position ||= "relative";

   
// --- TUNING ------------------------------------------------------------
const isMobile = window.matchMedia("(max-width: 749px)").matches;
const growUnits = isMobile ? 0.8 : 1.1;
const holdUnits = 0.5;
const totalScroll = growUnits + holdUnits;
const endVal = `+=${totalScroll * 100}%`;
const stickyHeight = `${(1 + totalScroll) * 100}svh`; // 100svh (initial viewport) + scroll distance

  // quick but hacky solution to override any other styles being applied to the heros parent element
  const heroParent = hero.parentElement;
  if (heroParent) {
      gsap.set(heroParent, {
          position: 'sticky',
          top: 0,
          // Set the height of the container to be the initial viewport height + the total scroll distance
          height: stickyHeight, 
      });
  }

// --- ScrollTrigger pin + videoBox scaling ---
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: hero,
        start: "top top",
        end: endVal,
        scrub: 1,
        invalidateOnRefresh: true,
        // pin: true,
        // pinSpacing: true,
        // anticipatePin: 1,
      },
      defaults: { ease: "none" },
    });

    // ----------------------------------------------------------------------
    // 📐 Helper: get responsive padding
    // ----------------------------------------------------------------------
    function getResponsivePadding() {
      return window.innerWidth <= 767 ? 16 : 20;
    }

    function paddedViewportWH() {
      const pad = getResponsivePadding();
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      return { w: Math.max(1, vw - pad * 2), h: Math.max(1, vh - pad * 2) };
    }

    // ----------------------------------------------------------------------
    // 🎬 Grow video while keeping bottom-right anchored
    // ----------------------------------------------------------------------
    const startSize = () => {
      const r = videoBox.getBoundingClientRect();
      return { w: r.width, h: r.height };
    };

  



// ----------------------------------------------------------------------
// 🎬 TEXT ROTATOR - FIXED VERSION
// ----------------------------------------------------------------------

/**
 * Creates an infinite, paused GSAP timeline for the text rotator
 * using a sequential fade (one fades out completely, then the next fades in).
 * @returns {gsap.core.Timeline | null} The paused timeline instance.
 */
function makeTextRotator() {
  const rotWrap = document.querySelector(".text-rotator");
  const items = rotWrap ? rotWrap.querySelectorAll(".rotator-item") : [];
  if (items.length < 2) {
    if (rotWrap && items.length === 1) {
      gsap.set(items[0], { opacity: 1 });
      gsap.set(rotWrap, { opacity: 1, visibility: 'visible' });
    }
    return null;
  }

  const holdDuration = 5; // Total time one item is visible (including fade-out)
  const fadeDuration = 1; // Time for a single fade (out or in)
  
  // 1. Establish the initial state outside the timeline
  gsap.set(items, { opacity: 0 });
  gsap.set(rotWrap, { opacity: 1, visibility: 'visible' });

  const tlRotator = gsap.timeline({
    repeat: -1, 
    paused: true,
    defaults: { ease: "power2.out", duration: fadeDuration }
  });
  
  let timePos = 0; // Absolute time marker for the timeline

  tlRotator.to(items[0], { opacity: 1 }, timePos);
  timePos += fadeDuration;

  // Build the cycle: Item 1 -> Item 2 -> Item 3 -> Item 1
  for (let i = 0; i < items.length; i++) {
    const currentItem = items[i];
    const nextItem = items[(i + 1) % items.length];
    
    // 1. Hold the current item's visibility
    // The hold lasts for (Hold time - Fade Out time - Fade In time)
    // The total duration of this *visual state* will be the gap before the fade out starts.
    const visualHoldTime = holdDuration - (2 * fadeDuration); 
    
    tlRotator.to({}, { duration: visualHoldTime, ease: "none" }, timePos);
    timePos += visualHoldTime;
    
    // 2. Sequential Fade Out
    // Fade out current item
    tlRotator.to(currentItem, { opacity: 0 }, timePos); 
    timePos += fadeDuration; // Advance timePos by the fade-out duration
    
    // 3. Sequential Fade In
    // Fade in next item, starting immediately after the fade-out completes
    tlRotator.to(nextItem, { opacity: 1 }, timePos); 
    timePos += fadeDuration; // Advance timePos by the fade-in duration
  }
  
  return tlRotator;
}

const rotLoop =
  typeof makeTextRotator === "function" ? makeTextRotator() : null;
const rotWrap = hero.querySelector(".text-rotator");

// Find and replace this section in your initNgaarluHero function:

console.log("startSize", startSize());

tl.fromTo(
  videoBox,
  {
    width: () => startSize().w,
    height: () => startSize().h,
  },
  {
    width: () => paddedViewportWH().w,
    height: () => paddedViewportWH().h,
    ease: "none",
    duration: growUnits,
    onStart: () => {
      const pad = getResponsivePadding();
      // videoBox.classList.remove("is-full");
      gsap.set(videoBox, {
        left: "auto",
        top: "auto",
        right: pad,
        bottom: pad,
        x: 0,
        y: 0,
      });
      hero.classList.remove("rotator-live");
      if (rotWrap) gsap.set(rotWrap, { opacity: 0 });
      
      // Pause animations on all items during grow
      const items = rotWrap?.querySelectorAll('.rotator-item');
      if (items) {
        items.forEach(item => {
          item.style.animationPlayState = 'paused';
        });
      }
    },
    onComplete: () => {
      console.log("[Hero] Growth complete on mobile");
      videoBox.classList.add("is-full");
      hero.classList.add("rotator-live");
      
      if (rotWrap) {
        // Fade in container
        gsap.to(rotWrap, { opacity: 1, duration: 0.4, ease: "power2.out" });
      }
      if (rotLoop) rotLoop.play();
    },
  }
)
.addLabel("afterGrowThreshold")
.add(() => {
  const dir = tl.scrollTrigger?.direction;
  console.log("[Hero] Callback fired, direction:", dir);
  
  if (dir === 1) {
    videoBox.classList.add("is-full");
    hero.classList.add("rotator-live");
    
    if (rotWrap) {
      const items = rotWrap.querySelectorAll('.rotator-item');

      // Fade in the rotator container
      gsap.to(rotWrap, { opacity: 1, duration: 0.4, ease: "power2.out" });
    }

    if (rotLoop) rotLoop.play(0);

  } else if (dir === -1) {
    videoBox.classList.remove("is-full");
    hero.classList.remove("rotator-live");

    if (rotWrap) {
      gsap.to(rotWrap, { opacity: 0, duration: 0.4, ease: "power1.out" });
    }

    if (rotLoop) rotLoop.pause();
  }
}, "afterGrowThreshold");

if (holdUnits > 0) tl.to({}, { duration: holdUnits });
    
// end of text rotator //

    console.debug("[Hero] Initialized (ESM)", {
      hero,
      videoBox,
      rotatorCount: rotator.length,
      endVal,
      growUnits,
      holdUnits,
    });
  }

  // ----------------------------------------------------------------------
  // 🧠 Safe init after fonts/layout are ready
  // ----------------------------------------------------------------------
  function safeInit() {
    if (window.__ngaarluHeroInited) return;
    window.__ngaarluHeroInited = true;
    initNgaarluHero();
  }

  if ("fonts" in document && document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => requestAnimationFrame(safeInit));
  } else if (document.readyState !== "loading") {
    safeInit();
  } else {
    document.addEventListener("DOMContentLoaded", safeInit, { once: true });
  }
})();



// 🚀  END OF HOMEPAGE HERO SCROLL ANIMATION (ESM-safe, anchored bottom-right grow)






  // ----------------------------------------------------------------------
  // 🧠 Add .scrolled class to body tag when on scroll
  // ----------------------------------------------------------------------

  document.addEventListener('DOMContentLoaded', function () {
    let lastScrollY = 0;
    const body = document.body;
    const threshold = 10; // Adjust to control sensitivity

    window.addEventListener('scroll', function () {
      if (window.scrollY > threshold && !body.classList.contains('scrolled')) {
        body.classList.add('scrolled');
      } else if (window.scrollY <= threshold && body.classList.contains('scrolled')) {
        body.classList.remove('scrolled');
      }
    });
  });

  // ----------------------------------------------------------------------
  // 🧠 Add color-scheme-4 class to footer when on contact page
  // ----------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", () => {
  if (document.body.classList.contains("template-contact") ||
      document.body.classList.contains("template-contact")) {
    const footerGroup = document.querySelector(".shopify-section-group-footer-group");
    if (footerGroup) footerGroup.classList.add("color-scheme-4");
  }
});



// ----------------------------------------------------------------------
// 🧠 Add class on second section template index when it reach the top
// ----------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function() {
  // Only run on homepage
  if (!document.body.classList.contains('template-index')) return;
  
  const secondSection = document.querySelector('main .shopify-section:nth-child(2)');
  if (!secondSection) return;

  ScrollTrigger.create({
    trigger: secondSection,
    start: 'top top',
    onEnter: () => document.body.classList.add('second-section-active'),
    onLeaveBack: () => document.body.classList.remove('second-section-active'),
    // markers: true // uncomment to debug
  });
});



// ----------------------------------------------------------------------
// 🧠 Add class tall-ratio if a product media is tall
// ----------------------------------------------------------------------




document.addEventListener('DOMContentLoaded', function() {
  const nodes = document.querySelectorAll('.product-media img, .product-media video');

  nodes.forEach(node => {
    const isImg = node.tagName === 'IMG';
    const isVideo = node.tagName === 'VIDEO';

    function checkRatio() {
      const width  = isImg ? node.naturalWidth  : node.videoWidth;
      const height = isImg ? node.naturalHeight : node.videoHeight;
      if (!width || !height) return;

      const wrapper = node.closest('.product-media');
      if (!wrapper) return;

      if (height / width > 1.2) wrapper.classList.add('tall-ratio');
      else wrapper.classList.remove('tall-ratio');
    }

    if (isImg) {
      if (node.complete) checkRatio();
      else node.addEventListener('load', checkRatio, { once: true });
    } else if (isVideo) {
      if (node.readyState >= 2) checkRatio();
      else node.addEventListener('loadedmetadata', checkRatio, { once: true });
    }
  });
});

// ----------------------------------------------------------------------
// 🧠 Hide player
// ----------------------------------------------------------------------


document.addEventListener("DOMContentLoaded", () => {
  // Watch for any <video> inside deferred-media
  const observer = new MutationObserver(() => {
    document.querySelectorAll('deferred-media video').forEach(video => {
      if (video.hasAttribute('controls')) {
        video.removeAttribute('controls');
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also handle videos already on page
  document.querySelectorAll('deferred-media video').forEach(video => {
    video.removeAttribute('controls');
  });
});





// ----------------------------------------------------------------------
// 🧠 force homepage drawer close (only on template-index)
// ----------------------------------------------------------------------



  /* Auto-close Horizon mobile drawer on same-page anchor links */
  (() => {
    const samePath = (a, b) =>
      a.replace(/\/+$/, "") === b.replace(/\/+$/, "");

    const isSamePageAnchor = (link) => {
      if (!link || !link.href) return false;
      const u = new URL(link.href, location.href);
      return (
        u.hash &&
        u.origin === location.origin &&
        samePath(u.pathname, location.pathname)
      );
    };

    const closeDrawer = () => {
      // Horizon variants (cover both details-based + button-based drawers)
      const openDetails =
        document.querySelector("header-drawer details[open]") ||
        document.querySelector(".menu-drawer details[open]");
      if (openDetails) openDetails.open = false;

      const closeBtn =
        document.querySelector("[data-drawer-close]") ||
        document.querySelector(".menu-drawer__close button, button[aria-label='Close menu'], .drawer__close");
      if (closeBtn) closeBtn.click?.();

      document.documentElement.classList.remove("prevent-scroll", "no-scroll");
      document.body.classList.remove("prevent-scroll", "no-scroll");
    };

    document.addEventListener(
      "click",
      (e) => {
        const link = e.target.closest("a[href]");
        if (!link || !isSamePageAnchor(link)) return;

        e.preventDefault();

        const hash = new URL(link.href, location.href).hash;
        const id = hash.slice(1);

        // Close the drawer first
        closeDrawer();

        // Update hash (without instant jump)
        if (hash) history.pushState(null, "", hash);

        const target = document.getElementById(id);
        if (!target) return;

        // Offset for sticky header, if any
        const header =
          document.querySelector(".header-section, header.header, .shopify-section-header-sticky");
        const offset = header ? header.getBoundingClientRect().height : 0;

        const buffer = 10; // 🔧 small top adjustment to remove extra 10px gap
        const y = target.getBoundingClientRect().top + window.pageYOffset - (offset + buffer);

        // Wait a bit for drawer close transition, then smooth scroll
        setTimeout(() => {
          window.scrollTo({ top: y, behavior: "smooth" });
        }, 250);
      },
      { passive: false }
    );
  })();


  /* Remove menu-open class when force close */
  document.addEventListener('DOMContentLoaded', function() {
    const menuDrawer = document.querySelector('[data-header-drawer]');
    
    if (menuDrawer) {
      const anchorLinks = menuDrawer.querySelectorAll('a[href*="#"]');
      
      anchorLinks.forEach(link => {
        link.addEventListener('click', function() {
          const href = this.getAttribute('href');
          
          if (href && href.includes('#')) {
            // Click the close button
            const closeButton = menuDrawer.querySelector('.menu-drawer__close-button');
            if (closeButton) {
              closeButton.click();
            }
            
            // Remove the menu-open class from the container
            const menuContainer = document.querySelector('.menu-drawer-container');
            if (menuContainer) {
              menuContainer.classList.remove('menu-open');
            }
          }
        });
      });
    }
  });


// ----------------------------------------------------------------------
// 🧠 END OF force homepage drawer close (scoped)
// ----------------------------------------------------------------------

